import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";
import OliverImage from "../../app/OliverImage";
import TooltipElement from "../Tooltip";
import "./style.scss";

type TextSizes = "xxl" | "xl" | "l" | "m" | "s" | "xs" | "xxs";
interface ToggleInputProps {
    title?: string;
    groupName: string;
    options?: { value: string; img: string; checked: boolean; disabled?: boolean; tooltip?: string }[];
    callback: (value: string) => void;
    textOptions?: { value: string; text: string; checked: boolean; textSize: TextSizes }[];
}

const RadioInput: React.FC<ToggleInputProps> = ({ title, groupName, options, textOptions, callback }: ToggleInputProps) => {
    const { t } = useTranslation();

    return (
        <div className="toggle-input-wrapper">
            {title && <OliverText text={t("generalComponents.radioInput." + title)} size="xs" />}
            <div className="toggle-input-options">
                {textOptions
                    ? textOptions.map((option, index) => (
                          <label key={index}>
                              <div className="option-text-wrapper">
                                  <OliverText
                                      key={index}
                                      text={t("generalComponents.radioInput." + option.text)}
                                      size={option.textSize}
                                      style={option.checked ? { color: "var(--blue)" } : {}}
                                  />
                              </div>
                              <input
                                  type="radio"
                                  name={groupName}
                                  value={option.value}
                                  checked={option.checked}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => callback(e.currentTarget.value)}
                              />
                          </label>
                      ))
                    : options
                    ? options.map((option, index) =>
                          option.tooltip && !option.disabled ? (
                              <TooltipElement key={index} text={option.tooltip}>
                                  <label>
                                      <OliverImage src={option.img} highlight={option.checked} />
                                      <input
                                          type="radio"
                                          name={groupName}
                                          value={option.value}
                                          checked={option.checked}
                                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => callback(e.currentTarget.value)}
                                      />
                                  </label>
                              </TooltipElement>
                          ) : (
                              <label key={index} className={option.disabled ? "disabled" : ""}>
                                  <OliverImage src={option.img} highlight={option.checked} />
                                  <input
                                      type="radio"
                                      name={groupName}
                                      value={option.value}
                                      checked={option.checked}
                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => callback(e.currentTarget.value)}
                                      disabled={option.disabled}
                                  />
                              </label>
                          )
                      )
                    : null}
            </div>
        </div>
    );
};

export default RadioInput;
